module.exports = __webpack_public_path__ + "img/Wp_2017.d14b9979.png";